import { h } from "preact";

import IconProps from "./IconProps";

function IconZoomIn({ width, height, color }: Omit<IconProps, "class">) {
    return (
        <svg width={width} height={height} viewBox="0 0 12 12">
            <g fill={color}>
                <rect x="5" width="2" height="12" rx="1"/>
                <rect y="5" width="12" height="2" rx="1"/>
            </g>
        </svg>
    );
}

IconZoomIn.defaultProps = {
    color: "var(--teflon)",
    width: 12,
    height: 12
};

export default IconZoomIn;
